import { StoreProps } from '@interfaces/StoreState'

export const selectUserProfile = (state: StoreProps) => state.activeState.userProfile
